// The app can be hosted under a path prefix (PUBLIC_URL=/feed). Everything that
// builds a root-relative URL by hand has to go through withBase() or it escapes
// that prefix. With PUBLIC_URL unset, BASE_PATH is "" and withBase() is a no-op.

export const computeBasePath = (publicUrl) => {
  let p = publicUrl || "";
  if (/^https?:\/\//i.test(p)) {
    try {
      p = new URL(p).pathname;
    } catch {
      p = "";
    }
  }
  return p.replace(/\/+$/, "");
};

export const BASE_PATH = computeBasePath(process.env.PUBLIC_URL);

export const withBase = (path, base = BASE_PATH) => {
  if (!base || typeof path !== "string" || !path.startsWith("/")) return path;
  if (path.startsWith("//")) return path; // protocol-relative URL
  if (path === base || path.startsWith(`${base}/`)) return path; // already prefixed
  return base + path;
};

// Inverse of withBase for router-relative use: "/feed/messages?x=1" -> "/messages?x=1".
// Router APIs (navigate, <Link>) add the basename themselves.
export const stripBase = (path, base = BASE_PATH) => {
  if (!base || typeof path !== "string") return path;
  if (path === base) return "/";
  const next = path.charAt(base.length);
  if (path.startsWith(base) && (next === "/" || next === "?" || next === "#")) {
    const rest = path.slice(base.length);
    return rest.startsWith("/") ? rest : `/${rest}`;
  }
  return path;
};

// Applies withBase to every root-relative string in a config object (tenant assets).
export const withBaseDeep = (value, base = BASE_PATH) => {
  if (typeof value === "string") return withBase(value, base);
  if (Array.isArray(value)) return value.map((v) => withBaseDeep(v, base));
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, withBaseDeep(v, base)]),
    );
  }
  return value;
};

// window.location.pathname includes the base path; route constants (pageURLs)
// do not. Use this wherever the current path is compared to a route.
export const getAppPathname = (base = BASE_PATH) =>
  stripBase(window.location.pathname, base);
